import './main.css'
import { useEffect, useState } from 'react';
import createPaymentLink from '../createCheckout/main';
import callAPI from '../fetch/main';
import { Descriptions, Progress, Row, Col, Button, Divider, Switch, Radio, Tooltip, Collapse, message, Alert, Badge, Table, Tag, Flex, Modal, Popover, Card, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CrownOutlined, DashboardOutlined, ExperimentOutlined, FireFilled, FireOutlined, RightCircleFilled, RiseOutlined, SafetyCertificateFilled, SafetyOutlined, StockOutlined, UserOutlined, CopyOutlined, CheckOutlined, StarFilled, ThunderboltFilled, RocketFilled } from '@ant-design/icons';
import dayjs from "dayjs";
import WhatsAppBanner from '../whatsappBanner/main';

function getRenewalInfo(startDate, monthsToAdd) {
    const start = dayjs(startDate);
    const renewalDate = start.add(monthsToAdd, 'month');
    const daysUntilRenewal = renewalDate.diff(dayjs(), 'day');
    return {
        daysUntilRenewal,
        nextRenewalDate: renewalDate.format('D MMM YYYY'),
    };
}

const getMonthsFromBilling = (billingText = "") => {
    const lower = billingText.toLowerCase();
    if (lower.includes("quarter")) return 3;
    if (lower.includes("two")) return 2;
    if (lower.includes("2")) return 2;
    if (lower.includes("bi")) return 2;
    if (lower.includes("semi")) return 6;
    if (lower.includes("annual") || lower.includes("year")) return 12;
    return 1;
};

function splitAmountPerDay(amountWithSymbol, days) {
    if (!amountWithSymbol || !days || days <= 0) return null;
    const match = amountWithSymbol.match(/^(\D*)([\d.,]+)/);
    if (!match) return null;
    const symbol = match[1];
    const amount = parseFloat(match[2].replace(/,/g, ''));
    if (isNaN(amount)) return null;
    const perDay = (amount / days).toFixed(2);
    return `${symbol}${perDay} per Day`;
}

function ShowPlans(props) {
    let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    let default_currency = "usd" //user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta" ? "inr" : "usd"
    const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)
    const [monthChange, setMonthChange] = useState('Yearly')

    const monthOptions = [
        { "value": 'Monthly', "label": "Monthly" },
        {
            "value": 'Yearly',
            "label": (
                <Popover
                    content={
                        <h4 style={{ color: "white", margin: "0" }}>
                            <CrownOutlined style={{ marginRight: "10px" }} color='purple' />
                            Save more by going yearly
                        </h4>
                    }
                    color="Purple"
                    placement="top"
                    open={monthChange === "Monthly"}
                >
                    Yearly (Save 20%)
                </Popover>
            )
        }
    ];

    const [showMonthlyPopup, setShowMontlyPopup] = useState()
    const [storeName, setStoreName] = useState(localStorage.getItem("shopify_store_"))
    const [selectedCategory, setSelectedCategory] = useState('single')
    const [selectedGateway, setSelectedGateway] = useState(showINR ? 'razorpay' : 'stripe')
    const [showBuyCreditsModal, setShowBuyCreditsModal] = useState(false);

    const creditPacks = [
        {
            id: "topup-1k",
            credits: "1,000",
            price: "$5",
            inr_price: "₹499",
            description: "Perfect for testing or small campaigns"
        },
        {
            id: "topup-20k",
            credits: "20,000",
            price: "$14",
            inr_price: "₹1,499",
            description: "Great for growing accounts"
        },
        {
            id: "topup-50k",
            credits: "50,000",
            price: "$24",
            inr_price: "₹2,999",
            description: "Best for active creators"
        },
        {
            id: "topup-100k",
            credits: "100,000",
            price: "$49",
            inr_price: "₹5,999",
            recommended: true,
            description: "High volume automation needs"
        },
        {
            id: "topup-500k",
            credits: "500,000",
            price: "$199",
            inr_price: "₹19,999",
            description: "For established businesses"
        },
        {
            id: "topup-1m",
            credits: "1,000,000",
            price: "$349",
            inr_price: "₹34,999",
            description: "Ultimate scale automation"
        }
    ];

    let plan_id_name = {
        free: "Free",
        566420: "Growth",
        566421: "Growth Yearly",
        566422: "Legend",
        566423: "Legend Yearly",
        428337: "Trendsetter",
        428338: "Trendsetter Yearly",
        "000003": "Legend Pro",
        "0000031": "Legend Pro Yearly",
        "trendsetter-pro-monthly": "Trendsetter Pro",
        "trendsetter-pro-yearly": "Trendsetter Pro Yearly",
        "multi-starter-monthly": "Multi Starter",
        "multi-starter-yearly": "Multi Starter Yearly",
        "multi-pro-monthly": "Multi Pro",
        "multi-pro-yearly": "Multi Pro Yearly",
        "multi-ultra-monthly": "Multi Ultra",
        "multi-ultra-yearly": "Multi Ultra Yearly",
    }

    const planNames = [
        // {
        //     key: "legend", 
        //     label: "Legend",
        //     icon: <RiseOutlined />,
        //     iconColor: "#6366f1",
        //     "id": "566422", 
        //     "yearly_id": "566423", 
        //     "name": "Legend", 
        //     "price": "$8.99", 
        //     "inr_price": "₹699", 
        //     "yearly_price": "$89.99", 
        //     "yearly_inr_price": "₹6,999",
        //     "yearly_month_price": "$7.49", 
        //     "yearly_month_inr_price": "₹582",
        //     "inr_monthly_regular": "₹1,000", 
        //     "monthly_regular": "$12",
        //     "billing": "Billed Monthly",
        //     "includes": [
        //         "Unlimited Automation (400/hour)",
        //         "Link Unlimited Posts & Stories",
        //         "Follow for link",
        //         "Reply to all comments",
        //         "Remove Branding",
        //         "Button Templates",
        //         "Priority Support"
        //     ],
        // },
        {
            key: "legend_pro",
            label: "Legend Pro",
            icon: <DashboardOutlined />,
            iconColor: "#8b5cf6",
            "id": "000003",
            "inr_monthly_regular": "₹1,499",
            "monthly_regular": "$18",
            "yearly_id": "0000031",
            "name": "Legend Pro",
            "price": "$12",
            "inr_price": "₹999",
            "yearly_price": "$120",
            "yearly_inr_price": "₹9,999",
            "yearly_month_price": "$9.99",
            "yearly_month_inr_price": "₹833",
            "billing": "Billed Monthly",
            "includes": [
                "Unlimited Automation (800/hour)",
                "Facebook + Instagram Automation",
                "10 Next Post Automation",
                "DM Automation",
                "Basic Dashboard",
                "Product Templates"
            ],
        },
        {
            key: "trendsetter",
            label: "Trendsetter",
            icon: <ThunderboltFilled />,
            iconColor: "#f59e0b",
            recommended: true,
            "id": "428337",
            "inr_monthly_regular": "₹4,499",
            "monthly_regular": "$50",
            "yearly_id": "428338",
            "name": "Trendsetter",
            "price": "$29.99",
            "inr_price": "₹1,999",
            "yearly_price": "$250",
            "yearly_inr_price": "₹19,999",
            "yearly_month_price": "$24.99",
            "yearly_month_inr_price": "₹1,666",
            "billing": "Billed Monthly",
            "includes": [
                "Unlimited Automation (2000/hour)",
                "Everything from Legend Pro",
                "Automate Post Shared to DM",
                "Boosted Reels Automation",
                "Flow Editor",
                "Advanced Dashboard",
                "Viral Mode Activator",
                "DM Queues",
                "Overload Handler",
                "Link Open Analytics",
                "Meta Ads Automation"
            ],
        },
        {
            key: "trendsetter_pro",
            label: "Trendsetter Pro",
            icon: <RocketFilled />,
            iconColor: "#10b981",
            secured: true,
            "id": "trendsetter-pro-monthly",
            "yearly_id": "trendsetter-pro-yearly",
            "inr_monthly_regular": "₹14,499",
            "monthly_regular": "$150",
            "name": "Trendsetter Pro",
            "price": "$59.99",
            "inr_price": "₹4,999",
            "yearly_price": "$599.99",
            "yearly_inr_price": "₹49,999",
            "yearly_month_price": "$49.99",
            "yearly_month_inr_price": "₹4,165",
            "billing": "Billed Monthly",
            "includes": [
                "No Hourly Limit",
                "Advanced Account Safety",
                "WhatsApp Support",
                "Advanced Dashboard",
                "Smart Slowdown Mode",
                "Priority Processing"
            ],
        }
    ];

    const multiAccountPlans = [
        {
            key: "multi_starter",
            label: "Multi Starter",
            icon: <UserOutlined />,
            iconColor: "#3b82f6",
            "id": "multi-starter-monthly",
            "yearly_id": "multi-starter-yearly",
            "name": "Multi Starter",
            "price": "$15",
            "inr_price": "₹1,299",
            "yearly_price": "$160",
            "yearly_inr_price": "₹12,999",
            "yearly_month_price": "$14",
            "yearly_month_inr_price": "₹1,084",
            "inr_monthly_regular": "₹1,999",
            "monthly_regular": "$24",
            "billing": "Billed Monthly",
            "includes": [
                "30,000 Automations per account / per month",
                "Maximum 3 Accounts",
                "Facebook + Instagram Automation",
                "10+ Next Post automation",
                "Boosted Reels Automation",
                "Meta Ads Automation",
                "Automate Post Shared to DM",
                "Flow Editor"
            ],
        },
        {
            key: "multi_pro",
            label: "Multi Pro",
            icon: <FireFilled />,
            iconColor: "#f59e0b",
            "id": "multi-pro-monthly",
            "yearly_id": "multi-pro-yearly",
            "name": "Multi Pro",
            "price": "$99",
            "inr_price": "₹7,999",
            "yearly_price": "$990",
            "yearly_inr_price": "₹79,999",
            "yearly_month_price": "$83",
            "yearly_month_inr_price": "₹6,667",
            "inr_monthly_regular": "₹12,999",
            "monthly_regular": "$149",
            "billing": "Billed Monthly",
            "includes": [
                "3,00,000 Automations per account / per month",
                "Maximum 10 Accounts",
                "Advanced Multi-Account Dashboard",
                "Team Collaboration Tools",
                "Viral Mode Activator",
                "DM Queues",
                "Overload Handler",
                "Advanced Account Safety",
                "WhatsApp Support"
            ],
        },
        {
            key: "multi_ultra",
            label: "Multi Ultra",
            icon: <RocketFilled />,
            iconColor: "#10b981",
            secured: true,
            "id": "multi-ultra-monthly",
            "yearly_id": "multi-ultra-yearly",
            "name": "Multi Ultra",
            "price": "$199",
            "inr_price": "₹15,999",
            "yearly_price": "$1990",
            "yearly_inr_price": "₹1,59,999",
            "yearly_month_price": "$166",
            "yearly_month_inr_price": "₹13,334",
            "inr_monthly_regular": "₹24,999",
            "monthly_regular": "$299",
            "billing": "Billed Monthly",
            "includes": [
                "Everything From Multi Pro",
                "Maximum 20 Accounts",
                "5,00,000 Automations per account / per month",
                "Early Access New Features",
                "Priority Support",
            ],
        }
    ];

    function createPaymentLinkFunc(plan) {
        const currency = selectedGateway === 'razorpay' ? 'inr' : 'usd';

        createPaymentLink(
            (monthChange == "Yearly" && plan.yearly_id) ? plan.yearly_id : plan.id,
            currency,
            props.messageApi,
            props.setPaymentLinkLoading,
            props.setPaymentLinkData,
            selectedGateway
        )

        let user_detail = JSON.parse(localStorage.getItem("userData"))
        let igid = localStorage.getItem("ig_id")
        const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
        const CHAT_ID = '776956029';
        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `[TRYING TO SUBSCRIBE] - user ${user_detail.emailid} - tried subscription for - ${plan.name}-${monthChange}, IG ID = ${igid}, user id = ${user_detail.user_id}, currency = ${showINR}`

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ chat_id: CHAT_ID, text: tele_message })
        }).catch(error => console.error('Error sending message:', error));
    }

    if (storeName) {
        return (
            <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px", minHeight: "100vh", padding: "40px 20px" }}>
                <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                    <h2 style={{ textAlign: "center", marginBottom: "40px" }}>Shopify Plans</h2>
                    <p style={{ textAlign: "center" }}>Your subscription will be managed by Shopify. Click to check pricing in Shopify admin page.</p>
                </div>
            </div>
        )
    }

    return (
        <div className="pricing-page" style={{ backgroundColor: "#fafafa", minHeight: "100vh", padding: "40px 20px" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto" }}>

                {/* Header Section */}
                <div style={{ textAlign: "center", marginBottom: "48px" }}>
                    <h1 style={{ fontSize: "42px", fontWeight: "700", margin: "0 0 16px 0", color: "#111" }}>
                        Simple, Transparent Pricing
                    </h1>
                    <p style={{ fontSize: "18px", color: "#666", margin: "0 0 32px 0" }}>
                        Choose the perfect plan for your automation needs
                    </p>

                    {/* Currency Toggle */}
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "16px", marginBottom: "32px" }}>
                        <span style={{ fontSize: "16px", color: "#666" }}>Currency:</span>
                        <Switch
                            checked={showINR}
                            checkedChildren="₹ INR"
                            unCheckedChildren="$ USD"
                            onChange={() => setShowINR(!showINR)}
                            style={{ minWidth: "60px" }}
                        />
                    </div>

                    {/* Category Toggle */}
                    <div style={{ marginBottom: "32px" }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "16px",
                            maxWidth: "700px",
                            margin: "0 auto",
                            overflowX: "auto"
                        }}>
                            <div
                                onClick={() => setSelectedCategory('single')}
                                style={{
                                    backgroundColor: selectedCategory === 'single' ? "#8b5cf6" : "#fff",
                                    color: selectedCategory === 'single' ? "#fff" : "#111",
                                    border: selectedCategory === 'single' ? "2px solid #8b5cf6" : "2px solid #e5e7eb",
                                    borderRadius: "12px",
                                    padding: "24px 20px",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    textAlign: "center",
                                    flex: "1",
                                    minWidth: "250px"
                                }}
                                className="category-card"
                            >
                                <div className="category-card-icon" style={{ fontSize: "32px", marginBottom: "12px" }}>
                                    <UserOutlined />
                                </div>
                                <h3 className="category-card-title" style={{
                                    margin: "0 0 8px 0",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: selectedCategory === 'single' ? "#fff" : "#111"
                                }}>
                                    One Account
                                </h3>
                                <p className="category-card-description" style={{
                                    margin: "0",
                                    fontSize: "14px",
                                    color: selectedCategory === 'single' ? "rgba(255,255,255,0.9)" : "#666"
                                }}>
                                    Unlimited automation for one account
                                </p>
                            </div>

                            <div
                                onClick={() => setSelectedCategory('multi')}
                                style={{
                                    backgroundColor: selectedCategory === 'multi' ? "#8b5cf6" : "#fff",
                                    color: selectedCategory === 'multi' ? "#fff" : "#111",
                                    border: selectedCategory === 'multi' ? "2px solid #8b5cf6" : "2px solid #e5e7eb",
                                    borderRadius: "12px",
                                    padding: "24px 20px",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    textAlign: "center",
                                    flex: "1",
                                    minWidth: "250px"
                                }}
                                className="category-card"
                            >
                                <div className="category-card-icon" style={{ fontSize: "32px", marginBottom: "12px" }}>
                                    <UserOutlined style={{ marginRight: "4px" }} />
                                    <UserOutlined />
                                </div>
                                <h3 className="category-card-title" style={{
                                    margin: "0 0 8px 0",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: selectedCategory === 'multi' ? "#fff" : "#111"
                                }}>
                                    Multi Account
                                </h3>
                                <p className="category-card-description" style={{
                                    margin: "0",
                                    fontSize: "14px",
                                    color: selectedCategory === 'multi' ? "rgba(255,255,255,0.9)" : "#666"
                                }}>
                                    Manage multiple accounts with automation limits
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Billing Toggle */}
                    <Radio.Group
                        options={monthOptions}
                        onChange={({ target: { value } }) => setMonthChange(value)}
                        value={monthChange}
                        optionType="button"
                        buttonStyle="solid"
                        size="large"
                        style={{
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            borderRadius: "8px"
                        }}
                    />
                </div>

                {/* Pricing Cards */}
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: "24px",
                    marginBottom: "48px"
                }}>
                    {(selectedCategory === 'single' ? planNames : multiAccountPlans.filter(p => p.key !== 'multi_ultra')).map((plan, idx) => {
                        const currentPrice = monthChange === "Yearly"
                            ? (showINR ? plan.yearly_month_inr_price : plan.yearly_month_price)
                            : (showINR ? plan.inr_price : plan.price);

                        const regularPrice = showINR ? plan.inr_monthly_regular : plan.monthly_regular;

                        return (
                            <div
                                key={idx}
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "16px",
                                    border: plan.recommended ? "2px solid #8b5cf6" : "1px solid #e5e7eb",
                                    padding: "32px 24px",
                                    position: "relative",
                                    boxShadow: plan.recommended
                                        ? "0 8px 24px rgba(139, 92, 246, 0.15)"
                                        : "0 2px 8px rgba(0,0,0,0.06)",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                className="pricing-card"
                            >
                                {/* Recommended Badge */}
                                {plan.recommended && (
                                    <div style={{
                                        position: "absolute",
                                        top: "-12px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "#8b5cf6",
                                        color: "#fff",
                                        padding: "4px 16px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px"
                                    }}>
                                        Most Popular
                                    </div>
                                )}

                                {/* Icon */}
                                <div style={{
                                    width: "56px",
                                    height: "56px",
                                    borderRadius: "12px",
                                    backgroundColor: `${plan.iconColor}15`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "20px",
                                    fontSize: "28px",
                                    color: plan.iconColor
                                }}>
                                    {plan.icon}
                                </div>

                                {/* Plan Name */}
                                <h3 style={{
                                    fontSize: "24px",
                                    fontWeight: "700",
                                    margin: "0 0 8px 0",
                                    color: "#111"
                                }}>
                                    {plan.label}
                                </h3>

                                {/* Pricing */}
                                <div style={{ marginBottom: "24px" }}>
                                    <div style={{ display: "flex", alignItems: "baseline", gap: "8px", marginBottom: "4px" }}>
                                        <span style={{
                                            fontSize: "40px",
                                            fontWeight: "700",
                                            color: "#111",
                                            lineHeight: "1"
                                        }}>
                                            {currentPrice}
                                        </span>
                                        <span style={{ fontSize: "16px", color: "#666" }}>
                                            /month{selectedCategory === 'multi' && plan.includes[1] ? ` for ${plan.includes[1].split(' ')[1]} Accounts` : ''}
                                        </span>
                                    </div>
                                    {regularPrice && (
                                        <div style={{
                                            fontSize: "14px",
                                            color: "#999",
                                            textDecoration: "line-through"
                                        }}>
                                            {regularPrice}/month
                                        </div>
                                    )}
                                    {monthChange === "Yearly" && (
                                        <div style={{
                                            fontSize: "14px",
                                            color: "#10b981",
                                            fontWeight: "500",
                                            marginTop: "4px"
                                        }}>
                                            Billed annually
                                        </div>
                                    )}
                                </div>

                                {/* CTA Button */}
                                <Button
                                    type={plan.recommended ? "primary" : "default"}
                                    size="large"
                                    block
                                    style={{
                                        height: "48px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        borderRadius: "8px",
                                        marginBottom: "24px",
                                        ...(plan.recommended ? {
                                            backgroundColor: "#8b5cf6",
                                            borderColor: "#8b5cf6"
                                        } : {})
                                    }}
                                    onClick={() => createPaymentLinkFunc(plan)}
                                >
                                    Switch Plan
                                </Button>

                                {/* Features List */}
                                <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "24px" }}>
                                    <div style={{ fontSize: "14px", fontWeight: "600", marginBottom: "16px", color: "#666" }}>
                                        FEATURES INCLUDED:
                                    </div>
                                    {plan.includes.map((feature, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "12px",
                                                marginBottom: "12px"
                                            }}
                                        >
                                            <CheckOutlined style={{
                                                color: plan.iconColor,
                                                fontSize: "16px",
                                                marginTop: "2px",
                                                flexShrink: 0
                                            }} />
                                            <span style={{ fontSize: "14px", color: "#444", lineHeight: "1.5" }}>
                                                {feature}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Payment Gateway Selection */}
                <div style={{
                    maxWidth: "600px",
                    margin: "0 auto 48px auto",
                    padding: "24px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
                }}>
                    <h3 style={{ margin: "0 0 8px 0", fontSize: "18px", fontWeight: "600", textAlign: "center" }}>
                        Select Payment Gateway
                    </h3>
                    <p style={{ margin: "0 0 20px 0", fontSize: "14px", color: "#666", textAlign: "center" }}>
                        Having issues with payment? Try a different payment gateway
                    </p>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <Radio.Group
                            value={selectedGateway}
                            onChange={(e) => setSelectedGateway(e.target.value)}
                            buttonStyle="solid"
                            size="large"
                        >
                            <Radio.Button value="stripe">
                                <span style={{ padding: "0 8px" }}>Stripe (USD)</span>
                            </Radio.Button>
                            <Radio.Button value="razorpay">
                                <span style={{ padding: "0 8px" }}>Razorpay (INR)</span>
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                    <p style={{ marginTop: "16px", fontSize: "14px", color: "#8b5cf6", fontWeight: "600", textAlign: "center" }}>
                        Select a plan to continue
                    </p>
                </div>

                {/* Current Subscription Card */}
                {props?.userPlan != undefined && (
                    <Card
                        style={{
                            maxWidth: "800px",
                            margin: "0 auto 48px auto",
                            borderRadius: "12px",
                            border: "1px solid #e5e7eb",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                        }}
                    >
                        <h3 style={{ margin: "0 0 20px 0", fontSize: "20px", fontWeight: "600" }}>Current Subscription</h3>
                        <Descriptions column={{ xs: 1, sm: 2 }} bordered size="middle">
                            <Descriptions.Item label="Plan">
                                <Tag color="blue" style={{ fontSize: "14px" }}>
                                    {plan_id_name[props?.userPlan?.data?.plan_details?.id] || "N/A"}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="Status">
                                {props?.userPlan?.data?.sub_status === "active" ? (
                                    <Tag icon={<CheckCircleOutlined />} color="success">Active</Tag>
                                ) : (
                                    <Tag icon={<CloseCircleOutlined />} color="error">Inactive</Tag>
                                )}
                            </Descriptions.Item>
                            <Descriptions.Item label="Buy More">
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={() => setShowBuyCreditsModal(true)}
                                    style={{ backgroundColor: "#8b5cf6", borderColor: "#8b5cf6" }}
                                >
                                    Buy Credits
                                </Button>
                            </Descriptions.Item>
                            <Descriptions.Item label="Monthly Usage">
                                {props?.userUsage?.data?.monthly_count || "Loading"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Renewal Date">
                                {props?.userPlan?.data?.plan_renew_date || "—"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                )}

                {/* WhatsApp Banner */}
                <div style={{ marginBottom: "32px" }}>
                    <WhatsAppBanner />
                </div>

            </div>

            {/* Buy Credits Modal */}
            <Modal
                title={<div style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700' }}>Buy DM Credits</div>}
                open={showBuyCreditsModal}
                onCancel={() => setShowBuyCreditsModal(false)}
                footer={null}
                width={800}
                centered
            >
                <div style={{ padding: '10px 0' }}>
                    <p style={{ textAlign: 'center', color: '#666', marginBottom: '24px' }}>
                        Top up your account with credits. These credits never expire and will be used after your plan credits are exhausted.
                    </p>
                    <Row gutter={[16, 16]}>
                        {creditPacks.map((pack) => (
                            <Col xs={24} sm={12} md={8} key={pack.id}>
                                <Badge.Ribbon
                                    text="Most Popular"
                                    color="purple"
                                    style={{ display: pack.recommended ? 'block' : 'none' }}
                                >
                                    <Card
                                        hoverable
                                        style={{
                                            borderRadius: '12px',
                                            border: pack.recommended ? '2px solid #8b5cf6' : '1px solid #e5e7eb',
                                            textAlign: 'center',
                                            height: '100%'
                                        }}
                                        bodyStyle={{ padding: '24px 16px' }}
                                        onClick={() => {
                                            const packData = {
                                                id: pack.id,
                                                name: `${pack.credits} Credits pack`
                                            };
                                            createPaymentLinkFunc(packData);
                                            setShowBuyCreditsModal(false);
                                        }}
                                    >
                                        <div style={{ fontSize: '20px', fontWeight: '700', color: '#111', marginBottom: '8px' }}>
                                            {pack.credits}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#8b5cf6', fontWeight: '600', marginBottom: '16px' }}>
                                            DM Credits
                                        </div>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#111', marginBottom: '8px' }}>
                                            {showINR ? pack.inr_price : pack.price}
                                        </div>
                                        <p style={{ fontSize: '12px', color: '#888', margin: 0, minHeight: '36px' }}>
                                            {pack.description}
                                        </p>
                                        <Button
                                            type="primary"
                                            block
                                            style={{
                                                marginTop: '16px',
                                                borderRadius: '8px',
                                                backgroundColor: pack.recommended ? '#8b5cf6' : '#fff',
                                                borderColor: '#8b5cf6',
                                                color: pack.recommended ? '#fff' : '#8b5cf6',
                                                fontWeight: '600'
                                            }}
                                        >
                                            Buy Now
                                        </Button>
                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Modal>
        </div>
    );
}

export default ShowPlans;
